import { UserApiUserDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useUserDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserDeleteRequest, config) =>
      appApiClient.userApi.userDelete(req, config),
  });
